<template>
  <app-panel title="Intéressé.e par cette formation ?">
    <course-page-actions :course="course" size="lg" />

    <p
      v-if="relatedCategoryPage"
      class="text-primary-950 before:bg-primary-100 before:-z-1 relative isolate -mb-7 mt-8 flex gap-3 py-2 text-sm before:absolute before:-left-7 before:-right-7 before:bottom-0 before:top-0 before:rounded"
    >
      <app-icon :icon="relatedCategoryPage.tag.icon" />
      <span>
        Découvrir les autres formations en
        <nuxt-link
          class="font-semibold underline"
          :to="relatedCategoryPage._links.page"
          >{{ relatedCategoryPage.tag.label }}</nuxt-link
        >
      </span>
    </p>
  </app-panel>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import CoursePageActions from "~/pages/courses/[slug]/_includes/components/course-page-actions.vue";

const properties = defineProps<{
  course: CoursePageView;
}>();

const { data: categoryPages } = useCategoryPageList({
  courses: [properties.course.id],
});

const relatedCategoryPage = computed(() => {
  return categoryPages.value?.[0];
});
</script>
